import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    previewImage: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: Theme.primaryBackgroundColor
    },
    infoButtonsContainer: {
        flexDirection: 'row',
        marginVertical: 10
    },
    leftButtonContainer: {
        marginRight: 15
    }
};

export default StyleSheet.create(baseStyles);
